<app-readonly-table #dt [columns]="columns" [isFilterable]="false" [paginator]="false" [itemsSource$]="listPayments$"
  [selectionMode]="null"  [isLoadLazy]="false" [totalRecords]="totalRecords">
</app-readonly-table>
